import { FrustumVisualizer } from './FrustumVisualizer.js';
import { Color4 as BABYLON_Color4 } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.color.js';
import { Matrix as BABYLON_Matrix } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.vector.js';
import { LineType } from '../../../api.js';
export class SpotlightShadowFrustumVisualizer extends FrustumVisualizer {
    constructor(_spotlight, viewer, color = new BABYLON_Color4(1), line_thickness = 0.05, line_type = LineType.DASHED) {
        super(viewer, color, line_thickness, line_type);
        this._spotlight = _spotlight;
    }
    get_matrices_ref(ref_view, ref_projection) {
        if (this._spotlight.shadow.enable_shadows && this._spotlight.shadow.shadow_view_matrix) {
            // Use view as Identity here, since shadow_view_matrix contains both
            // Using shadow_view_matrix also saves some calculations thanks to it being calculated in advance
            BABYLON_Matrix.IdentityToRef(ref_view);
            ref_projection.copyFrom(this._spotlight.shadow.shadow_view_matrix);
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=SpotlightShadowFrustumVisualizer.js.map